/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {
  DeliveryServiceVoModel,
  OptionalUiIdentifiableModel,
} from '@well/domain';
import { CostCenterResourceItemVO } from '@well/delivery-libs/cost-center/domain';
import { ContractTariffItemVoModel } from '@well/delivery-libs/contract-management/shell-domain';
import { NamedLocationVo } from '@well/named-location-management/shell-api-domain';
import { ShipmentFlowType } from '../index';
import { PackageResumeModel, PackageVoModel } from '@well/delivery-libs/packages/domain';
import { DateTimeWithTimezoneModel } from '@irian-ro/date-utils';
import { DelEmployeeVoModel } from '@well/delivery-libs/employee/domain';

export class ShipmentVoModel extends OptionalUiIdentifiableModel {
  uuid: string | null = null;
  customerUuid: string | null = null;
  customerName: string | null = null;
  deliveryAddress: any | undefined = undefined;
  pickupAddress: any | undefined = undefined;
  origin: string | null = null;
  destination: string | null = null;

  pickupNamedLocationVO: NamedLocationVo | null = null;
  deliveryNamedLocationVO: NamedLocationVo | null = null;

  orderNumber: string | null = null;

  numberOfPackages: string | null = null;
  packages: Array<PackageVoModel> = [];

  pickupIntervalStart: DateTimeWithTimezoneModel | null = null;
  pickupIntervalEnd: DateTimeWithTimezoneModel | null = null;
  pickupCompany: string | null = null;
  deliveryIntervalStart: DateTimeWithTimezoneModel| null = null;
  deliveryIntervalEnd: DateTimeWithTimezoneModel | null = null;
  deliveryCompany: string | null = null;

  fromOrder: boolean | null = null;
  packageResume: PackageResumeModel | null = null;
  shipmentBaseUuid: string | null = null;
  placedOnOfferRequest: boolean | null = null;
  pinned: boolean | null = null;
  requestingCompanyLeUuid: string | null = null;

  completeShipmentBaseUuid: string | null = null;

  spOfferRequestUuid: string | null = null;

  budget: number | null = null;
  cargoValue: number | null = null;
  service: DeliveryServiceVoModel | null = null;
  stackable: boolean | null = null;
  tags: Array<string> = [];

  shipmentFlowType: ShipmentFlowType | null = null;
  externalReference: string | null = null;

  costCenter: CostCenterResourceItemVO | null = null;

  contractTariffItemVO: ContractTariffItemVoModel | null = null;

  cronExpression: string | null = null;
  recurrenceEndDate: string | null = null;

  dispatcher: DelEmployeeVoModel | null = null;

  series : string | null = null;

  type: string | null = null;
}
